import { render, staticRenderFns } from "./XhProduct.vue?vue&type=template&id=27d9bdb2&scoped=true&"
import script from "./XhProduct.vue?vue&type=script&lang=js&"
export * from "./XhProduct.vue?vue&type=script&lang=js&"
import style0 from "./XhProduct.vue?vue&type=style&index=0&id=27d9bdb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d9bdb2",
  null
  
)

component.options.__file = "XhProduct.vue"
export default component.exports